import styled from '@emotion/styled';
import { mqUser } from 'utils/responsive';

interface Props {
    disabled: boolean;
    onClick: () => void;
}

const Button = styled.button`
    border: none;
    font-weight: 700;
    font-size: var(--font-medium);
    background-color: var(--white);
    color: var(--primary);
    border: 1px solid var(--primary);
    border-radius: 5px;
    padding: 8px 10px;
    cursor: pointer;

    :hover {
        opacity: 0.8;
    }

    ${mqUser('SP')} {
        width: 100%;
        font-size: var(--font-default);
    }
`;
export const SurveyButton: React.FC<Props> = ({ disabled, onClick }) => {
    return (
        <Button type="button" disabled={disabled} onClick={onClick}>
            アンケート回答
        </Button>
    );
};
